module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_brand1_jp.65ff167846d46682bcf2143ccaeebab4.png";